<template>
    <div class="mechanic-asset-details-line mechanic-asset-details-line--transfer">
        <div class="mechanic-asset-transfer-title">
            <b-badge variant="info" class="mechanic-asset-transfer-badge">
                Перемещается
            </b-badge>
        </div>
        <div class="mechanic-asset-transfer-route">
            <div class="mechanic-asset-transfer-point">
                <span>Откуда</span>
                <strong :title="fromText">{{ fromText }}</strong>
            </div>
            <div class="mechanic-asset-transfer-point">
                <span>Куда</span>
                <strong :title="toText">{{ toText }}</strong>
            </div>
        </div>
        <small v-if="extra" class="mechanic-asset-transfer-extra">
            {{ extra }}
        </small>
    </div>
</template>

<script>
export default {
  name: 'MechanicAssetTransferRoute',
  props: {
    from: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: ''
    },
    extra: {
      type: String,
      default: ''
    }
  },
  computed: {
    fromText() {
      return this.from || 'не указано';
    },
    toText() {
      return this.to || 'не указано';
    }
  }
};
</script>

<style scoped>
.mechanic-asset-details-line {
    display: block;
    margin-top: 4px;
    color: #6c757d;
    font-size: 0.82rem;
    line-height: 1.25;
    overflow-wrap: anywhere;
}

.mechanic-asset-details-line--transfer {
    padding: 6px 8px;
    border-left: 4px solid #17a2b8;
    border-radius: 4px;
    background: #dff5fb;
    color: #0c5460;
    font-weight: 600;
}

.mechanic-asset-transfer-title {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
}

.mechanic-asset-transfer-badge {
    flex-shrink: 0;
    text-transform: uppercase;
    letter-spacing: 0;
}

.mechanic-asset-transfer-route {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.mechanic-asset-transfer-point {
    display: grid;
    grid-template-columns: 52px minmax(0, 1fr);
    align-items: flex-start;
    column-gap: 6px;
    min-width: 0;
    padding: 4px 6px;
    border: 1px solid rgba(23, 162, 184, 0.35);
    border-radius: 4px;
    background: #ffffff;
}

.mechanic-asset-transfer-point span {
    display: block;
    color: #6c757d;
    font-size: 0.68rem;
    font-weight: 700;
    line-height: 1.25;
    text-transform: uppercase;
}

.mechanic-asset-transfer-point strong {
    display: block;
    min-width: 0;
    overflow-wrap: anywhere;
    white-space: normal;
    color: #083b44;
    font-size: 0.78rem;
    line-height: 1.25;
}

.mechanic-asset-transfer-extra {
    display: block;
    margin-top: 4px;
    color: #0c5460;
    font-weight: 500;
}

@media (max-width: 768px) {
    .mechanic-asset-details-line {
        width: 100%;
        font-size: 0.8rem;
    }

    .mechanic-asset-details-line--transfer {
        padding: 8px;
        border-left-width: 5px;
    }

    .mechanic-asset-transfer-title {
        margin-bottom: 6px;
    }

    .mechanic-asset-transfer-route {
        gap: 6px;
    }

    .mechanic-asset-transfer-point {
        grid-template-columns: minmax(0, 1fr);
        row-gap: 2px;
        padding: 6px 8px;
    }

    .mechanic-asset-transfer-point span {
        font-size: 0.64rem;
    }

    .mechanic-asset-transfer-point strong {
        font-size: 0.82rem;
    }
}
</style>
